module.exports = __webpack_public_path__ + "OpenSans-Regular.ac327c4db6284ef64ebe.woff";


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/node_modules/npm-font-open-sans/fonts/Regular/OpenSans-Regular.woff
// module id = ../../../../npm-font-open-sans/fonts/Regular/OpenSans-Regular.woff
// module chunks = styles